import { client } from "api";
import { PhotoComment } from "models/PhotoComment";

export type AddPhotoCommentRequest = { mediaId: string; comment: string };
export type AddPhotoCommentResponse = PhotoComment;

export const addPhotoComment = (request: AddPhotoCommentRequest) =>
  client.post<AddPhotoCommentResponse>(`/bin/add-photo-comment`, request).then((res) => res.data);
